// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Base del Header ===== */
.Header_header__Lhnr8 {
  background-color: var(--negroFooter);
  padding: 15px 5%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 1000;
  min-height: 80px;
}

.Header_logo__nZ7K6 img {
  height: 50px;
  width: auto;
}

.Header_nav__ZwnMZ {
  position: absolute;
  top: 80px;
  left: 0;
  width: 100%;
  background-color: #141414;
  transform: translateX(-100%);
  transition: transform 0.3s ease-in-out;
  overflow-y: auto; 
}

.Header_nav__ZwnMZ.Header_menuAbierto__OKDg9 {
  transform: translateX(0);
}

.Header_navLinks__s95Sk {
  list-style: none;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.Header_navLinks__s95Sk a, .Header_navLinks__s95Sk summary {
  color: var(--textoBlanco);
  font-weight: 500;
  font-size: 18px;
  padding: 15px 20px;
  display: block;
  cursor: pointer;
}

.Header_navLinks__s95Sk a:hover, .Header_navLinks__s95Sk summary:hover {
  color: var(--azul);
}

.Header_dropdown__bxE4- ul {
  list-style: none;
  padding-left: 20px; 
}
.Header_dropdown__bxE4- a {
  font-size: 16px;
}

.Header_acciones__MFRHq {
  display: flex;
  align-items: center;
  gap: 15px;
}

.Header_searchBtn__nSO7k {
  background: none;
  border: none;
  cursor: pointer;
}
.Header_searchBtn__nSO7k img {
  height: 24px;
  width: 24px;
}

.Header_btnAsesoria__nIoi\\+ {
  display: none;
  background-color: var(--naranja);
  color: var(--textoBlanco);
  padding: 12px 24px;
  border-radius: 5px;
  font-weight: 600;
}
.Header_btnAsesoria__nIoi\\+:hover {
  background-color: var(--azul);
  color: var(--textoBlanco);
}

.Header_hamburger__gyFYw {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.Header_hamburger__gyFYw div {
  width: 25px;
  height: 3px;
  background-color: var(--textoBlanco);
  border-radius: 5px;
  transition: all 0.3s ease;
}

.Header_hamburger__gyFYw.Header_abierto__YxYBP .Header_line1__V6ZOt {
  transform: rotate(45deg) translate(5px, 5px);
}
.Header_hamburger__gyFYw.Header_abierto__YxYBP .Header_line2__YkQRL {
  opacity: 0;
}
.Header_hamburger__gyFYw.Header_abierto__YxYBP .Header_line3__T4QeQ {
  transform: rotate(-45deg) translate(7px, -6px);
}


/* ===== MEDIA QUERY PARA DESKTOP (1025+) ===== */
@media (min-width: 1025px) {
  .Header_hamburger__gyFYw {
    display: none;
  }

  .Header_nav__ZwnMZ {
    position: static;
    transform: none;
    background: none;
    width: auto;
    overflow: visible;
  }

  .Header_navLinks__s95Sk {
    flex-direction: row;
    align-items: center;
    padding: 0;
    gap: 20px;
  }

  .Header_navLinks__s95Sk a, .Header_navLinks__s95Sk summary {
    font-size: 16px;
    padding: 5px 10px;
  }
  
  /* Estilos para el dropdown en desktop */
  .Header_dropdown__bxE4- {
    position: relative;
  }
  .Header_dropdown__bxE4- ul {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    background-color: #1f1f1f;
    padding: 10px;
    border-radius: 5px;
    min-width: 200px;
  }
  .Header_dropdown__bxE4-:hover ul, .Header_dropdown__bxE4- details[open] ul {
    display: block;
  }
  .Header_dropdown__bxE4- details > summary::-webkit-details-marker {
    display: none; 
  }
  .Header_dropdown__bxE4- summary {
    list-style: none; 
  }

  .Header_btnAsesoria__nIoi\\+ {
    display: inline-block;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header.module.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,oCAAoC;EACpC,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,yBAAyB;EACzB,4BAA4B;EAC5B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;AAC9C;AACA;EACE,UAAU;AACZ;AACA;EACE,8CAA8C;AAChD;;;AAGA,iDAAiD;AACjD;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA,wCAAwC;EACxC;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":["/* ===== Base del Header ===== */\n.header {\n  background-color: var(--negroFooter);\n  padding: 15px 5%;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  min-height: 80px;\n}\n\n.logo img {\n  height: 50px;\n  width: auto;\n}\n\n.nav {\n  position: absolute;\n  top: 80px;\n  left: 0;\n  width: 100%;\n  background-color: #141414;\n  transform: translateX(-100%);\n  transition: transform 0.3s ease-in-out;\n  overflow-y: auto; \n}\n\n.nav.menuAbierto {\n  transform: translateX(0);\n}\n\n.navLinks {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n}\n\n.navLinks a, .navLinks summary {\n  color: var(--textoBlanco);\n  font-weight: 500;\n  font-size: 18px;\n  padding: 15px 20px;\n  display: block;\n  cursor: pointer;\n}\n\n.navLinks a:hover, .navLinks summary:hover {\n  color: var(--azul);\n}\n\n.dropdown ul {\n  list-style: none;\n  padding-left: 20px; \n}\n.dropdown a {\n  font-size: 16px;\n}\n\n.acciones {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.searchBtn {\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n.searchBtn img {\n  height: 24px;\n  width: 24px;\n}\n\n.btnAsesoria {\n  display: none;\n  background-color: var(--naranja);\n  color: var(--textoBlanco);\n  padding: 12px 24px;\n  border-radius: 5px;\n  font-weight: 600;\n}\n.btnAsesoria:hover {\n  background-color: var(--azul);\n  color: var(--textoBlanco);\n}\n\n.hamburger {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.hamburger div {\n  width: 25px;\n  height: 3px;\n  background-color: var(--textoBlanco);\n  border-radius: 5px;\n  transition: all 0.3s ease;\n}\n\n.hamburger.abierto .line1 {\n  transform: rotate(45deg) translate(5px, 5px);\n}\n.hamburger.abierto .line2 {\n  opacity: 0;\n}\n.hamburger.abierto .line3 {\n  transform: rotate(-45deg) translate(7px, -6px);\n}\n\n\n/* ===== MEDIA QUERY PARA DESKTOP (1025+) ===== */\n@media (min-width: 1025px) {\n  .hamburger {\n    display: none;\n  }\n\n  .nav {\n    position: static;\n    transform: none;\n    background: none;\n    width: auto;\n    overflow: visible;\n  }\n\n  .navLinks {\n    flex-direction: row;\n    align-items: center;\n    padding: 0;\n    gap: 20px;\n  }\n\n  .navLinks a, .navLinks summary {\n    font-size: 16px;\n    padding: 5px 10px;\n  }\n  \n  /* Estilos para el dropdown en desktop */\n  .dropdown {\n    position: relative;\n  }\n  .dropdown ul {\n    display: none;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    background-color: #1f1f1f;\n    padding: 10px;\n    border-radius: 5px;\n    min-width: 200px;\n  }\n  .dropdown:hover ul, .dropdown details[open] ul {\n    display: block;\n  }\n  .dropdown details > summary::-webkit-details-marker {\n    display: none; \n  }\n  .dropdown summary {\n    list-style: none; \n  }\n\n  .btnAsesoria {\n    display: inline-block;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Header_header__Lhnr8`,
	"logo": `Header_logo__nZ7K6`,
	"nav": `Header_nav__ZwnMZ`,
	"menuAbierto": `Header_menuAbierto__OKDg9`,
	"navLinks": `Header_navLinks__s95Sk`,
	"dropdown": `Header_dropdown__bxE4-`,
	"acciones": `Header_acciones__MFRHq`,
	"searchBtn": `Header_searchBtn__nSO7k`,
	"btnAsesoria": `Header_btnAsesoria__nIoi+`,
	"hamburger": `Header_hamburger__gyFYw`,
	"abierto": `Header_abierto__YxYBP`,
	"line1": `Header_line1__V6ZOt`,
	"line2": `Header_line2__YkQRL`,
	"line3": `Header_line3__T4QeQ`
};
export default ___CSS_LOADER_EXPORT___;
